import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getWebStoryDetails = createAsyncThunk("webStoryDetails/getWebStoryDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getWebStoryDetails(payload);

    if (response.data.success) {
      return {
        ...response.data,
        story: response.data.story,
      };
    }
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

// Edit Web Story Clip
export const editWebStoryStoryClip = createAsyncThunk("webStoryEdit/editWebStoryStoryClip", async (payload) => {
  try {
    const response = await magnifiAPI.editWebStoryStoryClip(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getWebStoriesByOrganization = createAsyncThunk(
  "webStoryDetails/getWebStoriesByOrganization",
  async (payload) => {
    try {
      const response = await magnifiAPI.getWebStoriesByOrganization(payload);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
export const publishWebStory = createAsyncThunk("webStoryDetails/publishWebStory", async (payload) => {
  try {
    const response = await magnifiAPI.publishWebStory(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createWebStory = createAsyncThunk("webStory/createWebStory", async (payload) => {
  try {
    const response = await magnifiAPI.createWebStory(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
